"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _PurchaseTypes = require("self-service-api/constants/PurchaseTypes");

var _ContactsPicker = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ContactsPicker"));

var _SeatsPicker = _interopRequireDefault(require("../common/SeatsPicker"));

var _ContactsSliderContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ContactsSliderContainer"));

var _MarketingContactsSelectors = require("pricing-pages-unified-ui/selectors/MarketingContactsSelectors");

var AdditionalUnitsPicker = function AdditionalUnitsPicker(_ref) {
  var hub = _ref.hub,
      merchandiseId = _ref.merchandiseId,
      term = _ref.term,
      additionalUnitQuantity = _ref.additionalUnitQuantity,
      setAdditionalUnitQuantity = _ref.setAdditionalUnitQuantity,
      setActiveEdition = _ref.setActiveEdition;
  var isMarketingContactsSKU = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MarketingContactsSelectors.isMarketingContactsSKUSelector)(state, merchandiseId);
  });
  var merchPurchaseType = _HubMap.default[hub].merchPurchaseType;

  switch (merchPurchaseType) {
    case _PurchaseTypes.SEAT_BASED:
      return _react.default.createElement(_SeatsPicker.default, {
        merchandiseId: merchandiseId,
        additionalUnitQuantity: additionalUnitQuantity,
        onChange: setAdditionalUnitQuantity,
        term: term
      });

    case _PurchaseTypes.CONTACT_BASED:
      if (isMarketingContactsSKU) {
        return _react.default.createElement(_ContactsSliderContainer.default, {
          baseMerchId: merchandiseId,
          onChange: setAdditionalUnitQuantity,
          additionalUnitQuantity: additionalUnitQuantity,
          term: term,
          setActiveEdition: setActiveEdition
        });
      }

      return _react.default.createElement(_ContactsPicker.default, {
        merchandiseId: merchandiseId,
        additionalUnitQuantity: additionalUnitQuantity,
        onChange: setAdditionalUnitQuantity,
        term: term,
        setActiveEdition: setActiveEdition
      });

    default:
      return null;
  }
};

var _default = AdditionalUnitsPicker;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/AdditionalUnitsPicker.js
// module id = 808
// module chunks = 5 6